import { executeGet, executePost, api, resCode } from "./Network";

const pickAuthUrl = (response) => {
  const raw =
    response?.authUrl ||
    response?.auth_url ||
    response?.data?.authUrl ||
    response?.data?.auth_url ||
    null;
  if (typeof raw !== "string") return null;
  const url = raw.trim();
  return url.startsWith("http") ? url : null;
};

export const requestSosmedLogin = async () => {
  const response = await executeGet(api.sosmedLoginReq);
  if (response.code !== resCode.ok) {
    throw new Error(response.msg || "Gagal memulai login Google");
  }
  return response;
};

/** Ambil authUrl dari response BE bila sudah tersedia. */
export const getGoogleAuthUrl = (response) => pickAuthUrl(response);

export const verifySosmedLogin = async (email, fullname, jwtToken) => {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("nama", fullname);
  formData.append("token", jwtToken);
  formData.append("channel", "GOOGLE");
  const response = await executePost(api.sosmedLoginCheck, formData);
  if (response.code !== resCode.ok || !response.data) {
    throw new Error(response.msg || "Gagal login dengan Google");
  }
  return response;
};

/** Tukar code dari deep link BE (fase API). */
export const exchangeGoogleCode = async (code) => {
  const formData = new FormData();
  formData.append("code", code);
  formData.append("channel", "GOOGLE");
  const response = await executePost(api.sosmedLoginCheck, formData);
  if (response.code !== resCode.ok || !response.data) {
    throw new Error(response.msg || "Gagal menukar kode Google");
  }
  return response;
};
